import axios from "axios";
import apiConfig from "../config/apiConfig";

// Crear una instancia de Axios
const apiClient = axios.create({
  baseURL: apiConfig.baseURL,
  headers: apiConfig.defaultHeaders,
});

// Interceptor de respuesta (para manejar errores globales)
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("Error en la respuesta:", error.response || error.message);
    return Promise.reject(error);
  }
);

// Interceptor de solicitud (para agregar el token de autorización)
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("accessToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Interceptor para manejar 401 y hacer refresh
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const res = await apiClient.post("/refresh");
      if (res.status === 200) {
        localStorage.setItem("accessToken", res.data.accessToken);
        originalRequest.headers.Authorization = `Bearer ${res.data.accessToken}`;
        return apiClient(originalRequest);
      }
    }
    return Promise.reject(error);
  }
);
export default apiClient;
